import isEmpty from 'lodash/isEmpty';

export const buildBBox = ({ latitude, longitude }) => ({
    sw: { lng: longitude - 0.4, lat: latitude - 0.3 },
    ne: { lng: longitude + 0.4, lat: latitude + 0.3 },
});

export const buildLocationData = ({ locationData, location }) => {
    // locationData is empty when is called from tabs
    const _locationData = isEmpty(locationData) ? location : locationData;
    const { placeId, bbox, longitude, latitude } = _locationData;

    if (isEmpty(bbox) && longitude && latitude) {
        _locationData.bbox = buildBBox({ latitude, longitude });
    }

    /**
     * In some weird cases the placeId looked like
     * `recent-latitude-longitude`
     * Causing the calls to city browse to be weird.
     */
    if (placeId && placeId.match(/[recent]/g)) {
        _locationData.placeId = null;
    }

    return _locationData;
};
